/* eslint-disable import/no-mutable-exports */
const debugLog =
  process.env.NODE_ENV !== 'production' ? console.debug : () => {}; // eslint-disable-line no-console

export default debugLog;
